import { Tab, Box, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import API from "../../../api";
import CircularProgress from "@mui/material/CircularProgress";
import { TabContext, TabPanel, TabList } from "@mui/lab";
import Header from "../../../components/Header";
import ManageLocalAdmins from "./local-admins";
import ClientList from "./lecs-accounts/ClientList";

const AccountManagement = () => {
    const [tabValue, setTabValue] = useState("2"); // di default mostri la seconda tab
    const [auth, setAuth] = useState('');
    const [loadingAuth, setLoadingAuth] = useState(true);
    const commercial = sessionStorage.getItem("commercial")

    const TOChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        API.getResType().then(response => {
            const role = response.data.auth;
            setAuth(role);
            // se è super-admin, mostra la prima tab, altrimenti la seconda
            setTabValue(role === 'super-admin' ? "1" : "2");
        }).catch((err) => {
            console.error('[AccountManagement] Failed to fetch reseller type:', err);
        }).finally(() => {
            setLoadingAuth(false);
        });
    }, []);

    return (
        commercial === 'true' ? <Typography>Not authorized</Typography>
        : loadingAuth ? <Box display="flex" justifyContent="center" m="40px"><CircularProgress /></Box>
        :
        <Box m="20px">
            <Header title="ACCOUNT MANAGEMENT" />

            <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                    <TabList
                        onChange={TOChangeTab}
                        aria-label="Account management"
                        sx={{ "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: 13 } }}
                    >
                        {auth === 'super-admin' && <Tab label="Manage Local Admins" value="1" />}
                        <Tab label="Manage LECS Accounts" value="2" />
                    </TabList>
                </Box>

                {auth === 'super-admin' && (
                    <TabPanel value="1" sx={{ p: 0 }}>
                        <ManageLocalAdmins />
                    </TabPanel>
                )}
                <TabPanel value="2" sx={{ p: 0 }}>
                    <ClientList />
                </TabPanel>
            </TabContext>
        </Box>
    );
};

export default AccountManagement;
